var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.link.type !== "loading"
    ? _c("button", {
        class: ["toggle-button", "toggle-preview", { opened: _vm.link.shown }],
        attrs: { "aria-label": _vm.ariaLabel },
        on: { click: _vm.onClick },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }